export const supportedLanguages = ['en', 'pt'] as const
export type Language = (typeof supportedLanguages)[number]

export const defaultLanguage: Language = 'en'

export const defaultNS = 'common'
export const namespaces = ['common', 'home', 'call'] as const
export type Namespace = (typeof namespaces)[number]

export default {
	supportedLngs: [...supportedLanguages],
	fallbackLng: defaultLanguage,
	defaultNS,
	// Nested keys use dots (e.g. footer.privacy)
	// Arrays use returnObjects
	interpolation: {
		escapeValue: false, // React already escapes
	},
}
